import {Observable, forkJoin, map, of, switchMap} from 'rxjs';

interface PageEnvelope<T> {
  content?: T[];
  page?: {totalPages?: number};
}

/**
 * Alle Seiten einer pagenden Liste. Fehlt `page.totalPages`, bleibt es bei der ersten Seite.
 */
export function loadAllPages<T>(
  fetchPage: (page: number, size: number) => Observable<PageEnvelope<T>>,
  size: number,
): Observable<T[]> {
  return fetchPage(0, size).pipe(
    switchMap(first => {
      const content = first.content ?? [];
      const totalPages = first.page?.totalPages ?? 1;
      if (totalPages <= 1) return of(content);
      const rest = Array.from({length: totalPages - 1}, (_, i) => fetchPage(i + 1, size));
      return forkJoin(rest).pipe(
        map(pages => [...content, ...pages.flatMap(p => p.content ?? [])]),
      );
    }),
  );
}
